import { render, staticRenderFns } from "./BlogPostsModal.vue?vue&type=template&id=77487e67&scoped=true&"
import script from "./BlogPostsModal.vue?vue&type=script&lang=ts&"
export * from "./BlogPostsModal.vue?vue&type=script&lang=ts&"
import style0 from "./BlogPostsModal.vue?vue&type=style&index=0&id=77487e67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77487e67",
  null
  
)

export default component.exports